<template>
  <el-button :size="size" :type="type" :icon="icon"
    :loading="loading" :disabled="!hasPerms(perms)" @click="handleClick"
    :class="{'icon-only-btn': !label}">
    {{ showLabel }}
  </el-button>
</template>

<script>
import { hasPermission } from '@/permission/index.js'
export default {
  name: 'KtButton',
  props: {
    label: {  // 按钮显示文本
      type: String,
      default: null
    },
    icon: {  // 按钮显示图标
      type: String,
      default: ''
    },
    size: {  // 按钮尺寸
      type: String,
      default: 'mini'
    },
    type: {  // 按钮类型
      type: String,
      default: null
    },
    loading: {  // 按钮加载标识
      type: Boolean,
      default: false
    },
    disabled: {  // 按钮是否禁用
      type: Boolean,
      default: false
    },
    perms: {  // 按钮权限标识，外部使用者传入
      type: String,
      default: null
    }
  },
  computed: {
    showLabel() {
      return this.label || ''
    }
  },
  methods: {
    handleClick: function () {
      // 按钮操作处理函数
      this.$emit('click', {})
    },
    hasPerms: function (perms) {
      // 根据权限标识和外部使用者传入的状态进行权限判断
      return hasPermission(perms) & !this.disabled
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
/* 只显示图标时的样式 */
.icon-only-btn {
  padding: 6px 8px;
  min-width: 28px;
}

.icon-only-btn.el-button--mini {
  padding: 5px 7px;
  min-width: 26px;
}

.icon-only-btn.el-button--danger.icon-only-btn {
  padding: 5px 7px;
  min-width: 26px;
}
</style>



// WEBPACK FOOTER //
// src/views/Core/KtButton.vue